module.exports = __webpack_public_path__ + "static/media/bookmark-svgrepo-com (2).89c8f5e2.svg";